import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ContainerGroupField } from '@/components/common'
import { DatePickerControl, SelectControl } from '@/components/form-controls'
import { EducationFormData, OptionsField } from '@/types/forms'

interface HomologateControlProps {
    control: Control<EducationFormData>
    text: string
    watchEducationStatus: string | undefined
    optionStatusEducation: OptionsField[]
}
export const HomologateControl = ({
    control,
    text,
    watchEducationStatus,
    optionStatusEducation
}: HomologateControlProps): JSX.Element => {
    const { t } = useTranslation()

    const newText = `${text}.homologate`

    return (
        <ContainerGroupField tittleGroup={t('forms.groups.homologate')}>
            <SelectControl
                name="educationStatus"
                control={control}
                label={t(`${newText}.statusEducation`)}
                options={optionStatusEducation}
                rules={{
                    required: t(`${newText}.required.statusEducation`)
                }}
            />
            {watchEducationStatus === 'Graduado' && (
                <DatePickerControl
                    name="graduationDate"
                    control={control}
                    label={t(`${newText}.gradeDate`)}
                    rules={{
                        required: t(`${newText}.required.gradeDate`)
                    }}
                />
            )}
        </ContainerGroupField>
    )
}
